import Admin from "../Admin";
import React from "react";
import CardAdminMarketingCampaignCategoryList from "../../../Component/Card/Admin/MarketingCampaignCategory/CardAdminMarketingCampaignCategoryList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminMarketingCampaignCategoryList extends Admin {

    /**
     * Render the content.
     */
    renderContent() {
        return (
            <CardAdminMarketingCampaignCategoryList />
        );
    }

    renderHeader() {
        const handleClickCreate = () => {
            this.props.history.push({
                pathname: "/admin/marketingCampaignCategory"
            });
        };

        const buttons = [
            (<MUIButton
                component="label"
                variant="contained"
                startIcon={<MUIAddIcon />}
                onClick={handleClickCreate}>Create New</MUIButton>),
        ];

        return (
            <PageHeader title="Marketing Campaign Categories" buttons={buttons} />
        );
    }
}
